import extendIcon from '../../extendIcon';

export default extendIcon;
